import { POPUP_SECTIONS } from "../../../constant/constant.js";
import { DEFAULT_BRAND_ATTRIBUTION_DISPLAY } from "../../../../shared/brand-attribution.js";

export function createExtensionBrandAttributionSection() {
  return {
    type: POPUP_SECTIONS.BRAND_ATTRIBUTION,
    text: "",
    setting: {
      locked: true,
      role: "brandAttribution",
      display: { ...DEFAULT_BRAND_ATTRIBUTION_DISPLAY },
      customCSS: {
        desktop: {},
        mobile: {},
      },
      dimension: {
        desktop: { width: "100%", height: "auto" },
        mobile: { width: "100%", height: "auto" },
      },
    },
    UniqueElementKey: "",
    AIText: [],
  };
}

export function ensureExtensionBrandAttributionSections(sections = []) {
  const list = Array.isArray(sections) ? [...sections] : [];
  const hasBrand = list.some(
    (section) =>
      section?.type === POPUP_SECTIONS.BRAND_ATTRIBUTION ||
      section?.setting?.role === "brandAttribution"
  );

  if (hasBrand) return list;
  return [...list, createExtensionBrandAttributionSection()];
}
